// const _import = require('../_import_' + process.env.NODE_ENV)
// import consultIndex from 'page/consult/index'
// import consultExpertList from 'page/consult/expertList'
// import consultRank from 'page/consult/rank'
// import consultExpert from 'page/consult/expert'
// import consultRate from 'page/consult/rate'
// import consultSpecial from 'page/consult/special'
// import consultGuide from 'page/consult/guide'
// import preconsultList from 'page/consult/preconsultList'
// import scheduleList from 'page/consult/scheduleList'
// import care from 'page/consult/care'
// import pkg from 'page/consult/pkg'
// import teacherCeping from 'page/consult/teacherCeping.vue'
// import expertPreview from 'page/consult/expertPreview.vue'
// import hd from 'page/consult/hd.vue'

// import pageMixins from 'app/web/mixins/meditation/pageMixins'
// import pageMixin from 'mixins/consult/page'
// import mixinRoute from 'app/web/utils/mixinRoute.js'

// const consultIndex = () =>
//   import(/* webpackChunkName: "consultIndex" */ 'page/consult/index')

const consultPlacehold = () =>
  import(
    /* webpackChunkName: "consultPlacehold" */ 'page/consult/placehold.vue'
  )
const consultIndex = () =>
  import(/* webpackChunkName: "consultIndex" */ 'page/consult/indexV5')
const consultExpertList = () =>
  import(/* webpackChunkName: "consultexpertList" */ 'page/consult/expertList')

const consultRank = () =>
  import(/* webpackChunkName: "consultrank" */ 'page/consult/rank')

const consultNewRank = () =>
  import(/* webpackChunkName: "consultnewrank" */ 'page/consult/newRank')

const couponTeachers = () =>
  import(/* webpackChunkName: "couponTeachers" */ 'page/consult/couponTeachers')

const couponTeachersV2 = () =>
  import(
    /* webpackChunkName: "couponTeachers" */ 'page/consult/couponTeachersV2'
  )

const consultExpert = () =>
  import(/* webpackChunkName: "consultexpert" */ 'page/consult/expert')
const consultRate = () =>
  import(/* webpackChunkName: "consultrate" */ 'page/consult/rate')
const consultSpecial = () =>
  import(/* webpackChunkName: "consultspecial" */ 'page/consult/special')
// const consultGuide = () =>
//   import(/* webpackChunkName: "consultguide" */ 'page/consult/guide')
const consultHandbook = () =>
  import(/* webpackChunkName: "consultHandbook" */ 'page/consult/handbook')
const preconsultList = () =>
  import(
    /* webpackChunkName: "consultpreconsultList" */ 'page/consult/preconsultList'
  )
const scheduleList = () =>
  import(
    /* webpackChunkName: "consultscheduleList" */ 'page/consult/scheduleList'
  )
const fullMinusList = () =>
  import(
    /* webpackChunkName: "consultfullMinusList" */ 'page/consult/fullMinusList'
  )
const care = () =>
  import(/* webpackChunkName: "consultcare" */ 'page/consult/care')
const pkg = () =>
  import(/* webpackChunkName: "consultpkg" */ 'page/consult/pkg')
const teacherCeping = () =>
  import(
    /* webpackChunkName: "consultteacherCeping" */ 'page/consult/teacherCeping.vue'
  )
const expertPreview = () =>
  import(
    /* webpackChunkName: "consultexpertPreview" */ 'page/consult/expertPreview.vue'
  )
const hd = () =>
  import(/* webpackChunkName: "consulthd" */ 'page/consult/hd.vue')
const skipToConsult = () =>
  import(
    /* webpackChunkName: "skipToConsult" */ 'page/consult/skipToConsult.vue'
  )
const videoPage = () =>
  import(/* webpackChunkName: "videoPage" */ 'page/consult/video.vue')

const specialPriceList = () =>
  import(
    /* webpackChunkName: "specialPriceList" */ 'page/consult/specialPriceList.vue'
  )

const channel = () =>
  import(/* webpackChunkName: "consultchannel" */ 'page/consult/channel.vue')

const newUser = () =>
  import(/* webpackChunkName: "newUser" */ 'page/consult/newUser.vue')
const consultPopularity = () =>
  import(/* webpackChunkName: "popularity" */ 'page/consult/popularity.vue')

const userCenter = () =>
  import(/* webpackChunkName: "userCenter" */ 'page/consult/userCenter.vue')

const businessUserCenter = () =>
  import(
    /* webpackChunkName: "businessUserCenter" */ 'page/consult/businessUserCenter.vue'
  )

const myEvaluate = () =>
  import(/* webpackChunkName: "myEvaluate" */ 'page/consult/myEvaluate.vue')

// const consultRedirect = () =>
//   import(/* webpackChunkName: "consultRedirect" */ 'page/consult/redirect.vue')

const consultSpirit = () =>
  import(
    /* webpackChunkName: "consultRedirect" */ 'page/consult/spiritStateList.vue'
  )
const newsList = () =>
  import(/* webpackChunkName: "newsList" */ 'page/consult/newsList.vue')

const consultAbtest = () =>
  import(
    /* webpackChunkName: "consultAbtest" */ 'app/web/page/consult/consultAbtest.vue'
  )

const questionnaire = () =>
  import(
    /* webpackChunkName: "questionnaire" */ 'page/consult/questionnaire.vue'
  )

const newUserFall = () =>
  import(/* webpackChunkName: "newUserFall" */ 'page/consult/newUserFall.vue')

const newXiaoBaiUserFall = () =>
  import(
    /* webpackChunkName: "newXiaoBaiUserFall" */ 'page/consult/newXiaoBaiUserFall.vue'
  )

const newXingQuUserFall = () =>
  import(
    /* webpackChunkName: "newXingQuUserFall" */ 'page/consult/newXingQuUserFall.vue'
  )

const newUserWelfare = () =>
  import(
    /* webpackChunkName: "newUserWelfare" */ 'page/consult/newUserWelfare.vue'
  )

const offlineTreatment = () =>
  import(
    /* webpackChunkName: "offlineTreatment" */ 'page/consult/offlineTreatment.vue'
  )

// const myRoom = () =>
//   import(/* webpackChunkName: "myRoom" */ 'page/consult/myRoom.vue')

const myRoomV3 = () =>
  import(/* webpackChunkName: "myRoom" */ 'page/consult/myRoomV3.vue')

const reportContrast = () =>
  import(
    /* webpackChunkName: "reportContrast" */ 'page/consult/reportContrast.vue'
  )

const evaluatePaper = () =>
  import(
    /* webpackChunkName: "evaluatePaper" */ 'page/consult/evaluatePaper.vue'
  )

const myRoomGold = () =>
  import(/* webpackChunkName: "myRoomGold" */ 'page/consult/myRoomGold.vue')

const firstGuide = () =>
  import(/* webpackChunkName: "firstGuide" */ 'page/consult/firstGuide.vue')

const changeTeacher = () =>
  import(
    /* webpackChunkName: "changeTeacher" */ 'page/consult/changeTeacher.vue'
  )
const consultIndexOfAliPay = () =>
  import(
    /* webpackChunkName: "consultIndexOfAliPay" */ 'page/consult/indexOfAliPay'
  )
const consultIndexOfMeiTuan = () =>
  import(
    /* webpackChunkName: "consultIndexOfMeiTuan" */ 'page/meituan/indexOfMeiTuan'
  )
const mineOfMeiTuan = () =>
  import(/* webpackChunkName: "mineOfMeiTuan" */ 'page/meituan/mine')
const consultIndexOfPreRelease = () =>
  import(
    /* webpackChunkName: "consultIndexOfPreRelease" */ 'page/consult/indexOfPreRelease'
  )
const experience = () =>
  import(/* webpackChunkName: "experience" */ 'page/consult/experience.vue')

const guideDetails = () =>
  import(/* webpackChunkName: "experience" */ 'page/consult/guideDetails.vue')

const themeList = () =>
  import(/* webpackChunkName: "themeList" */ 'page/consult/themeList.vue')

const firstConsultationGuide = () =>
  import(
    /* webpackChunkName: "firstConsultationGuide" */ 'page/consult/firstConsultationGuide.vue'
  )

const VisitorLetter = () =>
  import(
    /* webpackChunkName: "VisitorLetter" */ 'page/consult/VisitorLetter.vue'
  )

const NoviceProcess = () =>
  import(
    /* webpackChunkName: "NoviceProcess" */ 'page/consult/NoviceProcess.vue'
  )

// const ConsultFinishedGuide = () =>
//   import(
//     /* webpackChunkName: "ConsultFinishedGuide" */ 'page/consult/consultFinishedGuide.vue'
//   )

const ConsultFinishedGuideV2 = () =>
  import(
    /* webpackChunkName: "consultFinishedGuideV2" */ 'page/consult/consultFinishedGuideV2.vue'
  )

const NegativeComment = () =>
  import(
    /* webpackChunkName: "NegativeComment" */ 'page/consult/negativeComment.vue'
  )

const GoodComment = () =>
  import(/* webpackChunkName: "GoodComment" */ 'page/consult/goodComment.vue')

const incentiveStatement = () =>
  import(
    /* webpackChunkName: "incentiveStatement" */ 'page/consult/incentiveStatement.vue'
  )

const liveCode = () =>
  import(/* webpackChunkName: "liveCode" */ 'page/consult/liveCode.vue')

const inviteRecommendTeacher = () =>
  import(
    /* webpackChunkName: "inviteRecommendTeacher" */ 'page/consult/inviteRecommendTeacher'
  )

const routes = [
  {
    path: '/consult/abtest',
    component: consultAbtest,
    meta: {
      clientOnly: true
    }
  },

  // {
  //   path: '/consult/redirect',
  //   component: consultRedirect
  // },

  {
    path: '/consult/alipay/index',
    component: consultIndexOfAliPay,
    meta: {
      pageName: '支付宝小程序咨询主页',
      business: '咨询'
    }
  },

  {
    path: '/consult/meituan/index',
    component: consultIndexOfMeiTuan,
    meta: {
      pageName: '美团小程序首页',
      business: '咨询'
    }
  },

  {
    path: '/consult/meituan/mine',
    component: mineOfMeiTuan,
    meta: {
      pageName: '美团小程序-我的',
      business: '咨询'
    }
  },

  {
    path: '/consult/preRelease/index',
    component: consultIndexOfPreRelease,
    meta: {
      pageName: '小程序咨询主页',
      business: '咨询'
    }
  },

  {
    path: '/consult',
    component: consultPlacehold,
    redirect: {
      name: 'indexForConsult'
    },
    children: [
      {
        path: '',
        name: 'indexForConsult',
        component: consultIndex,
        meta: {
          pageName: '咨询主页V5',
          business: '咨询',
          carryUserInfo: true
        }
      },
      {
        path: 'myroom',
        component: myRoomV3,
        meta: {
          pageName: '我的咨询室',
          business: '咨询'
        }
        // redirect: () => {
        //   return `/consult/myroom_v2`
        // }
      },
      {
        path: '/consult/reportContrast',
        component: reportContrast,
        meta: {
          pageName: '往期报告对比',
          business: '咨询'
        }
      },
      {
        path: 'newsList',
        component: newsList,
        meta: {
          pageName: '咨询消息列表',
          business: '咨询'
        },
        cache: false
      }
    ]
  },

  {
    path: '/consult_v5',
    redirect: () => {
      return `/consult`
    }
  },

  {
    path: '/consult/list',
    name: 'consultExpertList',
    component: consultExpertList,
    meta: {
      pageName: '咨询师列表',
      business: '咨询'
    }
  },

  {
    path: '/consult/list-*',
    name: 'consultExpertList',
    component: consultExpertList,
    meta: {
      pageName: '咨询师列表',
      business: '咨询'
    }
  },

  // {
  //   // path: /\/consult\/list$|(list-.*)/,
  //   // path: pathToRegexp('/consult/(list$|(list-.*))'),
  //   path: '/consult/list-*',
  //   name: 'consultExpertList',
  //   component: consultExpertList,
  //   meta: {
  //     pageName: '咨询师列表',
  //     business: '咨询'
  //   }
  // },

  {
    path: '/consult/channel',
    component: channel,
    meta: {
      pageName: '咨询渠道列表',
      business: '咨询',
      openAppModalOnSelf: true
    }
  },
  {
    path: '/consult/channel-*',
    component: channel,
    meta: {
      pageName: '咨询渠道列表',
      business: '咨询',
      openAppModalOnSelf: true
    }
  },

  {
    path: '/consult/rank/:id',
    component: consultRank,
    meta: {
      notKeepAlive: true,
      pageName: '榜单页',
      business: '咨询'
    }
  },
  {
    path: '/consult/newRank/:id',
    component: consultNewRank,
    meta: {
      notKeepAlive: true,
      pageName: '榜单页',
      business: '咨询'
    }
  },
  // 目前只针对测评业务的优惠券老师列表页（定制化）
  {
    path: '/consult/coupon/teachers',
    component: couponTeachers,
    meta: {
      pageName: '优惠券老师列表',
      business: '咨询',
      cache: false
    }
  },
  // 通用的优惠券老师列表页
  {
    path: '/consult/coupon/consultants',
    component: couponTeachersV2,
    meta: {
      pageName: '优惠券老师列表',
      business: '咨询',
      cache: false
    }
  },
  {
    path: '/consult/latest',
    component: consultSpecial,
    meta: {
      notKeepAlive: true,
      pageName: '最新入驻',
      business: '咨询'
    }
  },

  {
    path: '/consult/popularity',
    component: consultPopularity,
    meta: {
      notKeepAlive: true,
      pageName: '最佳人气',
      business: '咨询'
    }
  },

  {
    path: '/consult/teacherrate-*.html',
    component: consultRate,
    meta: {
      notKeepAlive: true,
      pageName: '咨询师评价页',
      business: '咨询'
    }
  },

  {
    path: '/expert/rate/:id',
    redirect: to => {
      return `/consult/teacherrate-${to.params.id}.html`
    }
  },

  {
    path: '/consult/hd-:id.html',
    component: hd,
    meta: {
      clientOnly: true,
      pageName: '活动详情',
      category: '活动',
      business: '咨询'
    }
  },

  {
    path: '/consult/teacherCeping-*.html',
    component: teacherCeping,
    meta: {
      pageName: '老师测评页',
      business: '咨询'
    }
  },

  {
    path: '/consult/*.html',
    name: 'consultExpert',
    component: consultExpert,
    meta: {
      notKeepAlive: true,
      pageName: '咨询师主页',
      business: '咨询'
    }
  },

  {
    path: '/expert/:id',
    name: 'consultExpert_1',
    redirect: to => {
      return `/consult/${to.params.id}.html`
    }
  },
  {
    path: '/expertPreview',
    name: 'expertPreview',
    component: expertPreview,
    meta: {
      pageName: '咨询师主页预览',
      business: '咨询'
    }
  },

  {
    path: '/consult/preconsult',
    name: 'preconsult',
    component: preconsultList,
    meta: {
      pageName: '咨询预沟通',
      business: '咨询',
      cache: false
    }
  },

  {
    path: '/consult/guide',
    component: consultHandbook,
    meta: {
      pageName: '咨询必读20问',
      business: '咨询'
    }
  },
  {
    path: '/consult/schedule-list',
    component: scheduleList,
    meta: {
      pageName: '今明可约',
      business: '咨询'
    }
  },
  {
    path: '/consult/full-minus-list',
    component: fullMinusList,
    meta: {
      pageName: '满减专区',
      business: '咨询'
    }
  },
  {
    path: '/consult/pkg/:id',
    component: pkg,
    meta: {
      pageName: '主题套餐详情页',
      business: '咨询'
    }
  },
  {
    path: '/consult/care',
    component: care,
    meta: {
      pageName: '学生优惠',
      business: '咨询'
    }
  },
  {
    path: '/consult/skip',
    component: skipToConsult,
    meta: {
      pageName: '壹心理咨询',
      business: '咨询'
      // openAppModalOnSelf: true
    }
  },
  {
    path: '/consult/video',
    component: videoPage,
    meta: {
      pageName: '咨询师视频播放页',
      business: '咨询'
    }
  },
  {
    path: '/consult/special-price',
    component: specialPriceList,
    meta: {
      pageName: '半价咨询',
      business: '咨询'
    }
  },
  {
    path: '/consult/newUser',
    component: newUser,
    meta: {
      pageName: '咨询新人福利页',
      business: '咨询'
    }
  },
  {
    path: '/consult/userCenter',
    component: userCenter,
    meta: {
      pageName: '个人中心',
      business: '咨询'
    }
  },
  // B端倾诉专用
  {
    path: '/consult/businessUserCenter',
    component: businessUserCenter,
    meta: {
      pageName: '个人中心',
      business: '咨询'
    }
  },
  {
    path: '/consult/evaluate',
    component: myEvaluate,
    meta: {
      pageName: '我的评价',
      business: '咨询'
    }
  },
  {
    path: '/consult/consultSpirit',
    component: consultSpirit,
    meta: {
      pageName: '精神状态评估',
      business: '咨询'
    }
  },
  {
    path: '/consult/questionnaire',
    component: questionnaire,
    meta: {
      pageName: '为我推荐',
      business: '咨询',
      keepAlive: true
    }
  },
  {
    path: '/consult/newUserFall',
    component: newUserFall,
    meta: {
      pageName: '咨询新人专区',
      business: '咨询'
    }
  },
  {
    path: '/consult/newXiaoBaiUserFall',
    component: newXiaoBaiUserFall,
    meta: {
      pageName: '咨询新人专区',
      business: '咨询'
    }
  },
  {
    path: '/consult/newXingQuUserFall',
    component: newXingQuUserFall,
    meta: {
      pageName: '咨询新人专区',
      business: '咨询'
    }
  },
  {
    path: '/consult/newUserWelfare',
    component: newUserWelfare,
    meta: {
      pageName: '低价心理咨询',
      business: '咨询'
    }
  },
  {
    path: '/consult/offline-treatment',
    component: offlineTreatment,
    meta: {
      pageName: '活动',
      business: '咨询'
    }
  },
  {
    path: '/consult/evaluatePaper',
    component: evaluatePaper,
    meta: {
      pageName: '咨询评价问卷',
      business: '咨询'
    }
  },
  {
    path: '/consult/myroom/gold',
    component: myRoomGold,
    meta: {
      pageName: '我的目标',
      business: '咨询'
    }
  },
  {
    path: '/consult/first-guide',
    component: firstGuide,
    meta: {
      pageName: '首次咨询',
      business: '咨询'
    }
  },
  {
    path: '/consult/changeTeacher',
    component: changeTeacher,
    meta: {
      pageName: '更换咨询师',
      business: '咨询'
    }
  },
  {
    path: '/experience',
    component: experience,
    meta: {
      pageName: '个人体验',
      business: '咨询'
    }
  },
  {
    path: '/guideDetails/:articleId',
    component: guideDetails,
    meta: {
      pageName: '',
      business: '咨询',
      cache: false
    }
  },
  {
    path: '/consult/themeList',
    component: themeList,
    meta: {
      pageName: '咨询主题分类页',
      business: '咨询'
    }
  },
  {
    path: '/consult/firstConsultationGuide',
    component: firstConsultationGuide,
    meta: {
      pageName: '首次咨询后会有什么感受？',
      business: '咨询'
    }
  },
  {
    path: '/consult/VisitorLetter',
    component: VisitorLetter,
    meta: {
      pageName: '壹心理创始人的一封信',
      business: '咨询'
    }
  },
  {
    path: '/consult/consultFinishedGuide/:consultId',
    component: ConsultFinishedGuideV2,
    meta: {
      pageName: '咨询已完成',
      business: '咨询'
    }
  },
  {
    path: '/consult/negativeComment/:consultId',
    component: NegativeComment,
    meta: {
      pageName: '评价页面',
      business: '咨询'
    }
  },
  {
    path: '/consult/goodComment/:consultId',
    component: GoodComment,
    meta: {
      pageName: '评价页面',
      business: '咨询'
    }
  },
  {
    path: '/consult/noviceProcess',
    component: NoviceProcess,
    meta: {
      pageName: '新手流程',
      business: '咨询'
    }
  },
  {
    path: '/consult/incentiveStatement',
    component: incentiveStatement,
    meta: {
      pageName: '咨询进程及激励',
      business: '咨询'
    }
  },
  {
    path: '/consult/liveCode',
    component: liveCode,
    meta: {
      pageName: '壹心理公益直播预约',
      business: '咨询'
    }
  },
  {
    path: '/consult/inviteRecommendTeacher',
    component: inviteRecommendTeacher,
    meta: {
      pageName: '推荐你喜欢的咨询师',
      business: '咨询'
    }
  }
]

export default routes // mixinRoute(routes, [pageMixin])
